import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { Grupo } from 'src/app/model/index.model';
import { GrupoService } from 'src/app/service/index.service';

@Component({
  selector: 'app-cb-grupo',
  templateUrl: './cb-grupo.component.html',
  styleUrls: ['./cb-grupo.component.scss']
})
export class CbGrupoComponent implements OnInit {
  @Input() require;
  @Input() disable;
  @Output() select = new EventEmitter<Grupo>()

  items: Grupo[];
  item: Grupo;

  public entity = "Grupo"

  constructor(private wsdl: GrupoService) { }

  ngOnInit() {
    this.lista();
  }

  onChange(item: Grupo) {
    this.select.emit(item);
  }

  @Input()
  set dibujar(item: Grupo) {
    if (item != undefined) {
      this.item = item;
    } else {
      this.item = new Grupo();
    }
  }

  compareFn(c1: Grupo, c2: Grupo): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  /*lista de item*/
  async lista() {
    try {

      let data = await this.wsdl.getList(1, 500).then();
      const result = JSON.parse(JSON.stringify(data));

      if (result.code == 200) {
        this.items = result.data.docs;
      } else if (result.code == 666) {
        // logout app o refresh token

      } else {
        this.items = [];
        UturuncoUtils.showToas(result.msg, "error");
      }
    } catch (error) {
      // UturuncoUtils.showToas("Excepción: " + error.message, "error");
    }
  }

}
